import type { FunctionComponent } from 'react';
import React, { useCallback, Suspense } from 'react';
import { useLazyComponent } from '@trello/use-lazy-component';
import { ErrorBoundary, ChunkLoadErrorBoundary } from '@trello/error-reporting';
import { ViewsErrorMessage } from 'app/src/components/ViewsErrorMessage';
import { WorkspaceViewCalendarSkeleton } from './WorkspaceViewCalendarSkeleton';

interface MultiBoardCalendarViewProps {
  idOrg: string;
}

export const MultiBoardCalendarView: FunctionComponent<MultiBoardCalendarViewProps> = ({
  idOrg,
}) => {
  const CalendarView = useLazyComponent(
    () => import(/* webpackChunkName: "calendar-view" */ './CalendarView'),
    { namedImport: 'CalendarView' },
  );

  const handleError = useCallback(() => {
    return (
      <>
        <ViewsErrorMessage
          screenEventName="multiBoardTableViewErrorScreen"
          analyticsContainers={{ organization: { id: idOrg } }}
        />
      </>
    );
  }, [idOrg]);

  return (
    <ErrorBoundary
      tags={{
        ownershipArea: 'trello-panorama',
        feature: 'Calendar View',
      }}
      errorHandlerComponent={handleError}
    >
      <Suspense fallback={<WorkspaceViewCalendarSkeleton />}>
        <ChunkLoadErrorBoundary fallback={handleError}>
          <CalendarView />
        </ChunkLoadErrorBoundary>
      </Suspense>
    </ErrorBoundary>
  );
};
